import * as React from "react";
import { useState, useEffect, useRef } from "react";
import {
  StepLabel,
  Box,
  Stepper,
  Step,
  Typography,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import "./Stepper.css";
import SelectAutoComplete from "../../ui/selectAutoComplete/SelectAutoComplete";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import {
  createClient,
  fetchDivisionesCFE,
  fetchTipoReportes,
  fetchUsuariosHabilitadosPM,
  createPermisionario,
  createProyecto,
  createTrabajo,
  updateTrabajo,
  buscarTrabajosPorCriterios,
  buscarTrabajosProyectos,
  editProyecto,
} from "../../components/functions/Projects";
import MapModal from "../../ui/map/MapaModal";
import EDTStepper from "./EDTStepper";
import { createTrackerProyecto } from "../../components/functions/Notifications";
import EditProjectModal from "../editProjectModal/EditProjectModal";
import EditClientModal from "../editProjectModal/EditClientModal";
import EditPermisionarioModal from "../editProjectModal/EditPermisionarioModal";
import ClienteContractualModal from "./ClienteContractualModal";
import { useNavigate } from "react-router-dom";

const steps = [
  "Suministrador / Permisionario",
  "Usuario final (socio consumidor)",
  "Proyecto",
  "Centro de carga",
  "Estructura de desglose de trabajo (EDT)",
];

export default function FormStepper({
  clients,
  projects,
  typeWorks,
  permisionarios,
  edit = false,
  API_URL,
  proyecto = {
    estado: null,
    permisionario: null,
    cliente: null,
    proyecto: null,
    nombre: "",
    direccion: "",
    latitude: null,
    longitude: null,
    rpu: "",
    divisionCFE: null,
    zonaCFE: null,
    tipoTrabajo: null,
    soporteRegionalCFE: false,
    nivelTension: null,
    demandaContratada: null,
    puntoCarga: "",
    clienteId: null,
    permisionarioId: null,
  },
  newWorkCenter = false,
  editWorkCenter = false,
  states = [],
  user,
  setProjects,
  setClients,
  setPermisionarios,
}) {
  const navigate = useNavigate();
  const showDialog = useConfirmDialog();

  const [tipos, setTipos] = useState([
    "existente",
    "existente",
    "existente",
    "existente",
    "existente",
  ]);

  const [activeStep, setActiveStep] = useState(
    newWorkCenter || editWorkCenter ? 3 : 0
  );

  const [completed, setCompleted] = useState(
    newWorkCenter || editWorkCenter
      ? {
          "Suministrador / Permisionario": true,
          "Usuario final (socio consumidor)": true,
          Proyecto: true,
        }
      : {}
  );

  const [tipoReportes, setTipoReportes] = useState([]);
  const [usuariosHabilitadosPM, setUsuariosHabilitadosPM] = useState([]);
  const [divisionesCFE, setDivisionesCFE] = useState([]);
  const [requiereURL, setRequiereURL] = useState(false);

  const [isMapModalOpen, setIsMapModalOpen] = useState(false); // Para controlar el modal del mapa para la dirección

  // Este es el formulario de proyecto que se usa para crear o editar el trabajo
  const [proyectoData, setProyectoData] = useState({
    ...proyecto,
    puntoCarga: proyecto.puntoCarga || "",
    rpu: proyecto.rpu || "",
    demandaContratada: proyecto.demandaContratada || 1,
  });

  const [permisionarioForm, setPermisionarioForm] = useState({
    razonSocial: "",
    alias: "",
  });

  const [clienteForm, setClienteForm] = useState({
    razonSocial: "",
    alias: "",
  });

  const [proyectoForm, setProyectoForm] = useState({
    nombre: "",
    numContable: "0",
    urlEncuesta: "",
    tipoReporte: null,
    tipoAlineacionLogoPrincipal: {
      lenguaje: "LEFT",
      name: "IZQUIERDA",
    },
    usuarioPM: null,
  });

  const [demandaContratadaNumber, setDemandaContratadaNumber] = useState(1);
  const [unidadMedida, setUnidadMedida] = useState({
    label: "kW",
    value: "kW",
  });
  const [demandaContratadaKW, setDemandaContratadaKW] = useState(1);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [openClienteContractualModal, setOpenClienteContractualModal] =
    useState(false);
  const [clientesContractuales, setClientesContractuales] = useState([]);
  const [selectedClienteContractual, setSelectedClienteContractual] =
    useState(null);

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => setOpenModal(false);
  const handleConfirmModal = (success, project) => {
    setShowSnackbar(true);
    setSnackbarMessage(
      success ? "Proyecto editado correctamente" : "Error al editar el proyecto"
    );
    setOpenModal(false);
    if (success) {
      const newProjects = projects.filter((p) => p.id !== project.id);
      newProjects.push(project);
      newProjects.sort((a, b) => a.nombre.localeCompare(b.nombre));
      setProjects(newProjects);
      setProyectoData((prev) => ({ ...prev, proyecto: project }));
    }
  };

  const [openModalPermisionario, setOpenModalPermisionario] = useState(false);
  const handleConfirmModalPermisionario = (success, permisionario) => {
    setShowSnackbar(true);
    setSnackbarMessage(
      success
        ? "Permisionario editado correctamente"
        : "Error al editar el permisionario"
    );
    setOpenModalPermisionario(false);
    if (success) {
      const newPermisionarios = permisionarios.filter(
        (p) => p.id !== permisionario.id
      );
      newPermisionarios.push(permisionario);
      newPermisionarios.sort((a, b) =>
        a.razonSocial.localeCompare(b.razonSocial)
      );
      setPermisionarios(newPermisionarios);
      setProyectoData((prev) => ({ ...prev, permisionario }));
    }
  };

  const [openModalCliente, setOpenModalCliente] = useState(false);
  const handleConfirmModalCliente = (success, cliente) => {
    setShowSnackbar(true);
    setSnackbarMessage(
      success ? "Cliente editado correctamente" : "Error al editar el cliente"
    );
    setOpenModalCliente(false);
    if (success) {
      const newClients = clients.filter((c) => c.id !== cliente.id);
      newClients.push(cliente);
      newClients.sort((a, b) => a.razonSocial.localeCompare(b.razonSocial));
      setClients(newClients);
      setProyectoData((prev) => ({ ...prev, cliente }));
    }
  };

  useEffect(() => {
    if (unidadMedida && unidadMedida.value && demandaContratadaNumber) {
      let demandaKW = demandaContratadaNumber;
      if (unidadMedida.value === "GW") {
        demandaKW = demandaContratadaNumber * 1000000;
      }
      if (unidadMedida.value === "MW") {
        demandaKW = demandaContratadaNumber * 1000;
      }
      setDemandaContratadaKW(demandaKW);
    }
  }, [demandaContratadaNumber, unidadMedida]);

  const totalSteps = () => steps.length;
  const completedSteps = () => Object.keys(completed).length;
  const isLastStep = () => activeStep === totalSteps() - 1;
  const allStepsCompleted = () => completedSteps() === totalSteps();

  useEffect(() => {
    if (newWorkCenter) {
      setProyectoData({
        ...proyecto,
        nombre: "",
        direccion: "",
        rpu: "",
        divisionCFE: null,
        zonaCFE: null,
        estado: null,
        latitude: null,
        longitude: null,
        soporteRegionalCFE: false,
        nivelTension: null,
        demandaContratada: 1,
        puntoCarga: "",
      });
    } else if (editWorkCenter) {
      if (proyecto && proyecto.demandaContratada) {
        if (proyecto.demandaContratada >= 1000000) {
          setUnidadMedida({ label: "GW", value: "GW" });
          setDemandaContratadaNumber(proyecto.demandaContratada / 1000000);
        } else if (proyecto.demandaContratada >= 1000) {
          setUnidadMedida({ label: "MW", value: "MW" });
          setDemandaContratadaNumber(proyecto.demandaContratada / 1000);
        } else {
          setUnidadMedida({ label: "kW", value: "kW" });
          setDemandaContratadaNumber(proyecto.demandaContratada);
        }
      } else {
        setUnidadMedida({ label: "kW", value: "kW" });
        setDemandaContratadaNumber(1);
      }
    }
    fetchDivisionesCFE(API_URL, setDivisionesCFE);
    fetchTipoReportes(API_URL, setTipoReportes);
    fetchUsuariosHabilitadosPM(API_URL, setUsuariosHabilitadosPM);

    // eslint-disable-next-line
  }, []);

  function changeTipo(index, value) {
    setTipos((prev) => {
      const newTiposArray = [...prev];
      newTiposArray[index] = value;
      return newTiposArray;
    });
  }

  const handleLocationSelect = (location) => {
    setProyectoData((prev) => ({
      ...prev,
      direccion: location.address,
      latitude: location.lat,
      longitude: location.lng,
    }));
  };

  const handleCreatePermisionario = async (payload) => {
    const duplicate = permisionarios.find(
      (item) => item.razonSocial === payload.razonSocial
    );

    if (duplicate) {
      showDialog({
        html: "El permisionario ingresado ya existe. Puedes seleccionarlo presionando la opción 'Existente'.",
        icon: "warning",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return null;
    }

    const inputWords = payload.razonSocial.toLowerCase().split(/\s+/);

    const similarPermisionarios = permisionarios.filter((perm) => {
      const permisionarioWords = perm.razonSocial.toLowerCase().split(/\s+/);
      return inputWords.some((word) => permisionarioWords.includes(word));
    });

    if (similarPermisionarios.length > 0) {
      const matches = similarPermisionarios
        .map((p) => `• ${p.razonSocial}`)
        .join("<br>");
      showDialog({
        html: `<p style="text-align: left;">Se encontraron permisionarios similares. Puedes seleccionarlos presionando la opción 'Existente'.<br><br>${matches}</p>`,
        icon: "warning",
        confirmButtonText: "Crear nuevo",
        mostrarCancelar: true,
        cancelButtonText: "Cancelar",
        showDenyButton: true,
        denyButtonText: "Elegir existente",
        denyButtonColor: "#223D51",
        cancelButtonColor: "gray",
        reverseButtons: true,
        onConfirm: async () => {
          await createPermisionarioLogic();
        },
        onDeny: () => {
          changeTipo(0, "existente");
          return;
        },
      });
      return;
    }

    async function createPermisionarioLogic() {
      try {
        const newPermisionario = await createPermisionario(API_URL, payload);
        permisionarios.push(newPermisionario);
        permisionarios.sort((a, b) =>
          a.razonSocial.localeCompare(b.razonSocial)
        );

        showDialog({
          html: "Permisionario creado exitosamente.",
          icon: "success",
          confirmButtonText: "Aceptar",
          mostrarCancelar: false,
        });
        setProyectoData((prev) => ({
          ...prev,
          permisionario: newPermisionario,
        }));
        setPermisionarioForm({ razonSocial: "", alias: "" });
        changeTipo(0, "existente");
        setCompleted({ ...completed, [steps[activeStep]]: true });
        handleNext();
        return;
      } catch (error) {
        showDialog({
          html: `Error al crear el permisionario:<br>${error.message}`,
          icon: "error",
          confirmButtonText: "Aceptar",
          mostrarCancelar: false,
        });
        return;
      }
    }

    await createPermisionarioLogic();
  };

  const handleCreateClient = async (payload) => {
    const duplicate = clients.find(
      (item) => item.razonSocial === payload.razonSocial
    );

    if (duplicate) {
      showDialog({
        html: "El cliente ingresado ya existe. Puedes seleccionarlo presionando la opción 'Existente'.",
        icon: "warning",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return null;
    }

    const inputWords = payload.razonSocial.toLowerCase().split(/\s+/);

    const similarClientes = clients.filter((cliente) => {
      const clienteWords = cliente.razonSocial.toLowerCase().split(/\s+/);
      return inputWords.some((word) => clienteWords.includes(word));
    });

    if (similarClientes.length > 0) {
      const matches = similarClientes
        .map((c) => `• ${c.razonSocial}`)
        .join("<br>");
      showDialog({
        html: `<p style="text-align: left;">Se encontraron usuarios finales similares. Puedes seleccionarlos presionando la opción 'Existente'.<br><br>${matches}</p>`,
        icon: "warning",
        confirmButtonText: "Crear nuevo",
        mostrarCancelar: true,
        cancelButtonText: "Cancelar",
        showDenyButton: true,
        denyButtonText: "Elegir existente",
        denyButtonColor: "#223D51",
        cancelButtonColor: "gray",
        reverseButtons: true,
        onConfirm: async () => {
          await createClientLogic();
        },
        onDeny: () => {
          changeTipo(1, "existente");
          return null;
        },
      });
      return null;
    }

    async function createClientLogic() {
      try {
        const newCliente = await createClient(API_URL, payload);
        clients.push(newCliente);
        clients.sort((a, b) => a.razonSocial.localeCompare(b.razonSocial));

        showDialog({
          html: "Cliente creado exitosamente.",
          icon: "success",
          confirmButtonText: "Aceptar",
          mostrarCancelar: false,
        });

        setProyectoData((prev) => ({ ...prev, cliente: newCliente }));
        setClienteForm({ razonSocial: "", alias: "" });
        changeTipo(1, "existente");
        setCompleted({ ...completed, [steps[activeStep]]: true });
        handleNext();
        setOpenClienteContractualModal(true);
        setClientesContractuales([newCliente, proyectoData.permisionario]);
        return;
      } catch (error) {
        showDialog({
          html: `Error al crear el cliente:<br>${error.message}`,
          icon: "error",
          confirmButtonText: "Aceptar",
          mostrarCancelar: false,
        });
        return;
      }
    }

    await createClientLogic();
  };

  const handleCreateProyecto = async (payload, finalizar) => {
    payload.clienteId = proyectoData.cliente?.id;
    payload.permisionarioId = proyectoData.permisionario?.id;
    payload.clienteContractual = selectedClienteContractual?.razonSocial;

    const duplicate = projects.find((item) => item?.nombre === payload?.nombre);

    if (duplicate) {
      showDialog({
        html: "El proyecto ingresado ya existe. Puedes seleccionarlo presionando la opción 'Existente'.",
        icon: "warning",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return null;
    }

    const inputWords = payload.nombre.toLowerCase().split(/\s+/);

    const similarProjects = projects.filter((project) => {
      const projectWords = project?.nombre?.toLowerCase().split(/\s+/);
      return inputWords.some((word) => projectWords?.includes(word));
    });

    if (similarProjects.length > 0) {
      const matches = similarProjects.map((p) => `• ${p.nombre}`).join("<br>");
      showDialog({
        html: `<p style="text-align: left;">Se encontraron proyectos similares. Puedes seleccionarlos presionando la opción 'Existente'.<br><br>${matches}</p>`,
        icon: "warning",
        confirmButtonText: "Crear nuevo",
        mostrarCancelar: true,
        cancelButtonText: "Cancelar",
        showDenyButton: true,
        denyButtonText: "Elegir existente",
        denyButtonColor: "#223D51",
        cancelButtonColor: "gray",
        reverseButtons: true,
        onConfirm: async () => {
          await createProjectLogic();
        },
        onDeny: () => {
          changeTipo(2, "existente");
          return null;
        },
      });
      return null;
    }

    async function createProjectLogic() {
      try {
        const newProyecto = await createProyecto(API_URL, payload);
        projects.push(newProyecto);
        projects.sort((a, b) => a.nombre.localeCompare(b.nombre));

        showDialog({
          html: "Proyecto creado exitosamente.",
          icon: "success",
          confirmButtonText: "Aceptar",
          mostrarCancelar: false,
        });
        setProyectoData((prev) => ({ ...prev, proyecto: newProyecto }));
        setProyectoForm({ razonSocial: "", alias: "" });
        changeTipo(2, "existente");
        setCompleted({ ...completed, [steps[activeStep]]: true });
        handleNext();
        if (finalizar) {
          navigate(`/proyectos`);
        }
        return;
      } catch (error) {
        showDialog({
          html: `Error al crear el proyecto:<br>${error.message}`,
          icon: "error",
          confirmButtonText: "Aceptar",
          mostrarCancelar: false,
        });
        return;
      }
    }

    await createProjectLogic();
  };

  const handleCompleteCreateEDT = async (edt) => {
    showDialog({
      html: "EDT creada exitosamente.",
      icon: "success",
      confirmButtonText: "Aceptar",
      mostrarCancelar: false,
    });
    setProyectoData((prev) => ({ ...prev, tipoTrabajo: edt }));
    setCompleted({ ...completed, [steps[activeStep]]: true });
    if (!edit) {
      const proyectoUpdatePayload = {
        ...proyectoData?.proyecto,
        clienteId: proyectoData?.cliente?.id,
        permisionarioId: proyectoData?.permisionario?.id,
        clienteContractual: selectedClienteContractual?.razonSocial,
      };

      await editProyecto(API_URL, proyectoUpdatePayload);

      handleCreateTrabajo({ ...proyectoData, tipoTrabajo: edt });
    } else {
      handleUpdateTrabajo({ ...proyectoData, tipoTrabajo: edt });
    }
  };

  const handleCreateTrabajo = async (payload) => {
    try {
      const newTrabajo = await createTrabajo(API_URL, payload);
      await buscarTrabajosProyectos(
        API_URL,
        {
          id: null,
          nombre: null,
          puntoCarga: null,
          rpu: null,
          proyecto: null,
          cliente: null,
          permisionario: { id: payload.permisionario.id },
          empresa: null,
          tipoTrabajo: null,
          estatus: null,
          direccion: null,
          parametro: null,
          latitude: null,
          longitude: null,
          estado: null,
          nivelTension: null,
          demandaContratada: null,
          porcentajeFotos: null,
          porcentajeParametros: null,
        },
        async (response) => {
          const lastTrabajo = response[response.length - 1];
          await createTrackerProyecto(API_URL, {
            id_usuario: user.id,
            id_trabajo: lastTrabajo.id,
            nombre: lastTrabajo.nombre,
            etapa: 2,
            estatus: "pendiente",
          });
        },
        (response) => {}
      );

      showDialog({
        html: "Trabajo creado exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return newTrabajo;
    } catch (error) {
      showDialog({
        html: `Error al crear el trabajo:<br>${error.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return null;
    }
  };

  const handleUpdateTrabajo = async (payload) => {
    try {
      const newTrabajo = await updateTrabajo(API_URL, payload);

      showDialog({
        html: "Trabajo actualizado exitosamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return newTrabajo;
    } catch (error) {
      showDialog({
        html: `Error al actualizar el trabajo:<br>${error.message}`,
        icon: "error",
        confirmButtonText: "Aceptar",
        mostrarCancelar: false,
      });
      return null;
    }
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () =>
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const handleComplete = async (finalizar = false) => {
    switch (activeStep) {
      case 0:
        if (tipos[0] === "existente") {
          if (proyectoData.permisionario) {
            setCompleted({ ...completed, [steps[activeStep]]: true });
            handleNext();
          } else {
            showDialog({
              html: "Por favor, selecciona un permisionario existente.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
          }
          return;
        }

        if (
          permisionarioForm.razonSocial.length === 0 ||
          permisionarioForm.alias.length === 0
        ) {
          showDialog({
            html: "Por favor, completa todos los campos del permisionario, o elige uno existente.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
          return;
        }

        await handleCreatePermisionario({
          ...permisionarioForm,
          comentarios: null,
        });

        return;
      case 1:
        if (tipos[1] === "existente") {
          if (proyectoData.cliente) {
            setCompleted({ ...completed, [steps[activeStep]]: true });
            handleNext();
            setOpenClienteContractualModal(true);
            setClientesContractuales([
              proyectoData.cliente,
              proyectoData.permisionario,
            ]);
          } else {
            showDialog({
              html: "Por favor, selecciona un usuario final existente.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
          }
          return;
        }

        if (
          clienteForm.razonSocial.length === 0 ||
          clienteForm.alias.length === 0
        ) {
          showDialog({
            html: "Por favor, completa todos los campos del usuario final, o elige uno existente.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
          return;
        }

        await handleCreateClient({
          ...clienteForm,
          comentarios: null,
          id: null,
        });
        return;
      case 2:
        if (tipos[2] === "existente") {
          if (proyectoData.proyecto) {
            setCompleted({ ...completed, [steps[activeStep]]: true });
            handleNext();
          } else {
            showDialog({
              html: "Por favor, selecciona un proyecto final existente.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
          }
          return;
        }

        if (
          proyectoForm.nombre.length === 0 ||
          proyectoForm.numContable.length === 0 ||
          proyectoForm.usuarioPM === null ||
          proyectoForm.tipoReporte === null ||
          (requiereURL && proyectoForm.urlEncuesta.length === 0)
        ) {
          showDialog({
            html: "Por favor, completa todos los campos del proyecto, o elige uno existente.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
          return;
        }

        await handleCreateProyecto(
          {
            ...proyectoForm,
            comentarios: null,
            id: null,
          },
          finalizar
        );
        return;
      case 3:
        if (!proyectoData.permisionario) {
          showDialog({
            html: "Para avanzar, debes seleccionar un permisionario.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
          return;
        }
        if (
          proyectoData.nombre.length === 0 ||
          proyectoData?.rpu?.length === 0 ||
          proyectoData.divisionCFE === null ||
          proyectoData?.direccion?.length === 0 ||
          proyectoData.estado === null ||
          proyectoData.nivelTension === null ||
          Object.keys(proyectoData.nivelTension).length === 0 ||
          demandaContratadaNumber === null ||
          unidadMedida === null ||
          Object.keys(unidadMedida).length === 0 ||
          proyectoData.puntoCarga.length === 0
        ) {
          showDialog({
            html: "Por favor, completa todos los campos del centro de carga.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
          return;
        } else {
          setCompleted({ ...completed, [steps[activeStep]]: true });
          let demanda = demandaContratadaNumber; // kilowatts por defecto

          if (unidadMedida.value === "MW") {
            demanda = demandaContratadaNumber * 1000;
          } else if (unidadMedida.value === "GW") {
            demanda = demandaContratadaNumber * 1000000;
          }

          setProyectoData((prev) => ({
            ...prev,
            demandaContratada: Number(demanda),
            nivelTension: proyectoData.nivelTension.value,
          }));
          handleNext();
        }
        break;
      case 4:
        if (tipos[4] === "existente") {
          if (proyectoData.tipoTrabajo) {
            setCompleted({ ...completed, [steps[activeStep]]: true });
            if (!edit || newWorkCenter) {
              const proyectoUpdatePayload = {
                ...proyectoData.proyecto,
                clienteId: proyectoData.cliente?.id,
                permisionarioId: proyectoData.permisionario?.id,
                clienteContractual: selectedClienteContractual?.razonSocial,
              };

              await editProyecto(API_URL, proyectoUpdatePayload);
              handleCreateTrabajo(proyectoData);
            } else {
              handleUpdateTrabajo(proyectoData);
            }
          } else {
            showDialog({
              html: "Por favor, selecciona una Estructura de Desglose de Trabajo existente.",
              icon: "warning",
              confirmButtonText: "Aceptar",
              mostrarCancelar: false,
            });
          }
          return;
        } else {
          handleNextStepEDT();
        }
        break;
      default:
        setCompleted({ ...completed, [steps[activeStep]]: true });
        handleNext();
        break;
    }
  };

  const edtRef = useRef();

  const handleNextStepEDT = () => {
    edtRef.current.handleNext();
  };

  const renderStepContent = () => {
    // PASO 1: Suministrador / Permisionario
    if (activeStep === 0) {
      return (
        <Box
          sx={{
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0px 0px 5px 2px #DDDDDD",
            padding: "24px",
            minHeight: "562px",
          }}
        >
          <h1 style={{ justifySelf: "center" }} className="stepper-title">
            {steps[0]}
          </h1>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <CustomButton
                background={tipos[0] === "nuevo" ? "#223D51" : "#FFFFFF"}
                color={tipos[0] === "nuevo" ? "#FFFFFF" : "#223D51"}
                text="Crear nuevo"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => {
                  changeTipo(0, "nuevo");
                }}
                type="button"
              />
              <CustomButton
                background={tipos[0] === "existente" ? "#223D51" : "#FFFFFF"}
                color={tipos[0] === "existente" ? "#FFFFFF" : "#223D51"}
                text="Existente"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => changeTipo(0, "existente")}
                type="button"
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              paddingY: "20px",
            }}
          >
            {tipos[0] === "existente" && (
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <SelectAutoComplete
                  options={permisionarios}
                  field="permisionario"
                  fieldC="razonSocial"
                  value={proyectoData.permisionario || ""}
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({
                      ...prev,
                      permisionario: value,
                    }))
                  }
                />
                <CustomButton
                  disabled={!proyectoData.permisionario?.id}
                  background={
                    proyectoData.permisionario?.id ? "#223D51" : "#c3c3c3"
                  }
                  color={"#FFFFFF"}
                  text="Editar"
                  width="100px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenModalPermisionario(true);
                  }}
                  type="button"
                />
              </Box>
            )}
            {tipos[0] === "nuevo" && (
              <Box
                className="stepper-step-content"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <div
                  className="d-grid align-items-center"
                  style={{ gridTemplateColumns: "120px 1fr", rowGap: "16px" }}
                >
                  <label className="form-label">Razón social:</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Ingresa la razón social"
                    value={permisionarioForm.razonSocial || ""}
                    onChange={(e) =>
                      setPermisionarioForm((prev) => ({
                        ...prev,
                        razonSocial: e.target.value,
                      }))
                    }
                    min={1}
                  />
                  <label className="form-label">Nombre corto:</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Ingresa el nombre corto"
                    value={permisionarioForm.alias || ""}
                    onChange={(e) =>
                      setPermisionarioForm((prev) => ({
                        ...prev,
                        alias: e.target.value,
                      }))
                    }
                    min={1}
                  />
                </div>
              </Box>
            )}
          </Box>
        </Box>
      );
    }

    // PASO 2: Usuario final (socio consumidor)
    if (activeStep === 1) {
      return (
        <Box
          sx={{
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0px 0px 5px 2px #DDDDDD",
            padding: "24px",
            minHeight: "562px",
          }}
        >
          <h1 style={{ justifySelf: "center" }} className="stepper-title">
            {steps[1]}
          </h1>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <CustomButton
                background={tipos[1] === "nuevo" ? "#223D51" : "#FFFFFF"}
                color={tipos[1] === "nuevo" ? "#FFFFFF" : "#223D51"}
                text="Crear nuevo"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => {
                  changeTipo(1, "nuevo");
                }}
                type="button"
              />
              <CustomButton
                background={tipos[1] === "existente" ? "#223D51" : "#FFFFFF"}
                color={tipos[1] === "existente" ? "#FFFFFF" : "#223D51"}
                text="Existente"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => changeTipo(1, "existente")}
                type="button"
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              paddingY: "20px",
            }}
          >
            {tipos[1] === "existente" && (
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <SelectAutoComplete
                  options={clients}
                  fieldC="razonSocial"
                  field="clients"
                  value={proyectoData.cliente || ""}
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({ ...prev, cliente: value }))
                  }
                />
                <CustomButton
                  disabled={!proyectoData.cliente?.id}
                  background={proyectoData.cliente?.id ? "#223D51" : "#c3c3c3"}
                  color={"#FFFFFF"}
                  text="Editar"
                  width="100px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenModalCliente(true);
                  }}
                  type="button"
                />
              </Box>
            )}
            {tipos[1] === "nuevo" && (
              <Box
                className="stepper-step-content"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <div
                  className="d-grid align-items-center"
                  style={{ gridTemplateColumns: "120px 1fr", rowGap: "16px" }}
                >
                  <label className="form-label">Razón social:</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Ingresa razón social"
                    value={clienteForm.razonSocial || ""}
                    minLength={1}
                    onChange={(e) =>
                      setClienteForm((prev) => ({
                        ...prev,
                        razonSocial: e.target.value,
                      }))
                    }
                  />
                  <label className="form-label">Nombre corto:</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Ingresa nombre corto"
                    value={clienteForm.alias || ""}
                    minLength={1}
                    onChange={(e) =>
                      setClienteForm((prev) => ({
                        ...prev,
                        alias: e.target.value,
                      }))
                    }
                  />
                </div>
              </Box>
            )}
          </Box>
        </Box>
      );
    }

    // PASO 3: Proyecto
    if (activeStep === 2) {
      return (
        <Box
          sx={{
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0px 0px 5px 2px #DDDDDD",
            padding: "24px",
            minHeight: "562px",
          }}
        >
          <h1 style={{ justifySelf: "center" }} className="stepper-title">
            {steps[2]}
          </h1>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <CustomButton
                background={tipos[2] === "nuevo" ? "#223D51" : "#FFFFFF"}
                color={tipos[2] === "nuevo" ? "#FFFFFF" : "#223D51"}
                text="Crear nuevo"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => {
                  changeTipo(2, "nuevo");
                }}
                type="button"
              />
              <CustomButton
                background={tipos[2] === "existente" ? "#223D51" : "#FFFFFF"}
                color={tipos[2] === "existente" ? "#FFFFFF" : "#223D51"}
                text="Existente"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => changeTipo(2, "existente")}
                type="button"
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              paddingY: "20px",
            }}
          >
            {tipos[2] === "existente" && (
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <SelectAutoComplete
                  options={projects}
                  fieldC="nombre"
                  field="proyecto"
                  value={proyectoData.proyecto || ""}
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({ ...prev, proyecto: value }))
                  }
                />
                <CustomButton
                  disabled={!proyectoData.proyecto?.id}
                  background={proyectoData.proyecto?.id ? "#223D51" : "#c3c3c3"}
                  color={"#FFFFFF"}
                  text="Editar"
                  width="100px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenModal(true);
                  }}
                  type="button"
                />
              </Box>
            )}
            {tipos[2] === "nuevo" && (
              <Box
                className="stepper-step-content"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <div
                  className="d-grid align-items-center"
                  style={{ gridTemplateColumns: "250px 1fr", rowGap: "16px" }}
                >
                  <label className="form-label">Nombre:</label>
                  <input
                    className="form-input"
                    type="text"
                    placeholder="Ingresa el nombre"
                    value={proyectoForm?.nombre || ""}
                    onChange={(e) =>
                      setProyectoForm((prev) => ({
                        ...prev,
                        nombre: e.target.value,
                      }))
                    }
                  />
                  <label className="form-label">Tipo de reporte:</label>
                  <SelectAutoComplete
                    options={tipoReportes}
                    field="proyecto.tipoReporte"
                    fieldC="descripcion"
                    width={"100%"}
                    value={proyectoForm?.tipoReporte || {}}
                    onChange={(e, value) =>
                      setProyectoForm((prev) => ({
                        ...prev,
                        tipoReporte: value,
                      }))
                    }
                  />
                  <label className="form-label" htmlFor="soporteRegionalCFE">
                    ¿Requiere URL de encuesta de satisfacción?
                  </label>
                  <label className="switch">
                    <input
                      id="soporteRegionalCFE"
                      type="checkbox"
                      checked={requiereURL}
                      onChange={(e) => setRequiereURL((prev) => !prev)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <label
                    style={{
                      display: requiereURL ? "block" : "none",
                    }}
                    className="form-label"
                  >
                    URL Encuesta de satisfacción:
                  </label>
                  <input
                    style={{
                      display: requiereURL ? "block" : "none",
                    }}
                    className="form-input"
                    type="text"
                    placeholder="Ingresa URL"
                    value={proyectoForm?.urlEncuesta || ""}
                    onChange={(e) =>
                      setProyectoForm((prev) => ({
                        ...prev,
                        urlEncuesta: e.target.value,
                      }))
                    }
                  />
                  <label className="form-label">
                    PM responsable del proyecto:
                  </label>
                  <SelectAutoComplete
                    options={usuariosHabilitadosPM}
                    field="proyecto.usuarioPM"
                    fieldC="nombre"
                    width={"100%"}
                    value={proyectoForm?.usuarioPM || {}}
                    onChange={(e, value) =>
                      setProyectoForm((prev) => ({
                        ...prev,
                        usuarioPM: value,
                      }))
                    }
                  />
                </div>
              </Box>
            )}
          </Box>
        </Box>
      );
    }

    // PASO 4: Centro de carga (formulario directo)
    if (activeStep === 3) {
      return (
        <Box
          sx={{
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0px 0px 5px 2px #DDDDDD",
            padding: "24px",
            minHeight: "562px",
          }}
        >
          <h1 style={{ justifySelf: "center" }} className="stepper-title">
            {steps[3]}
          </h1>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              paddingY: "20px",
            }}
          >
            <Box
              className="stepper-step-content"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <div
                className="d-grid align-items-center"
                style={{ gridTemplateColumns: "250px 1fr", rowGap: "16px" }}
              >
                <label title="Nombre igual a ODOO" className="form-label">
                  Nombre del centro de carga:
                </label>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <input
                    className="form-input"
                    style={{ margin: "0px" }}
                    type="text"
                    title="Nombre igual a ODOO"
                    name="nombreCentroCarga"
                    placeholder="Ingresa el nombre igual a ODOO"
                    value={proyectoData.nombre || ""}
                    onChange={(e) =>
                      setProyectoData((prev) => ({
                        ...prev,
                        nombre: e.target.value,
                      }))
                    }
                  />
                  <span style={{ color: "gray", fontSize: "13px" }}>
                    Nombre igual a ODOO
                  </span>
                </div>
                <label className="form-label">RPU:</label>
                <input
                  className="form-input"
                  type="text"
                  name="rpu"
                  placeholder="Ingresa RPU"
                  value={proyectoData?.rpu || ""}
                  onChange={(e) =>
                    setProyectoData((prev) => ({
                      ...prev,
                      rpu: e.target.value,
                    }))
                  }
                />
                <label className="form-label">Punto de carga:</label>
                <input
                  className="form-input"
                  type="text"
                  name="puntoCarga"
                  placeholder="Ingresa el punto de carga"
                  value={proyectoData?.puntoCarga || ""}
                  onChange={(e) =>
                    setProyectoData((prev) => ({
                      ...prev,
                      puntoCarga: e.target.value,
                    }))
                  }
                />
                <label className="form-label">División de CFE:</label>
                <SelectAutoComplete
                  size="small"
                  options={divisionesCFE}
                  field="divisionCFE"
                  fieldC="nombreCorto"
                  width={"100%"}
                  value={proyectoData?.divisionCFE || {}}
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({
                      ...prev,
                      divisionCFE: value,
                    }))
                  }
                />
                <label className="form-label">Nivel de tensión:</label>
                <SelectAutoComplete
                  size="small"
                  options={[
                    { value: "BT", label: "BT" },
                    { value: "MT", label: "MT" },
                    { value: "AT", label: "AT" },
                  ]}
                  field="nivelTension"
                  width={"100%"}
                  value={
                    [
                      { value: "BT", label: "BT" },
                      { value: "MT", label: "MT" },
                      { value: "AT", label: "AT" },
                    ].find(
                      (option) => option.value === proyectoData?.nivelTension
                    ) || {}
                  }
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({
                      ...prev,
                      nivelTension: value.value || "",
                    }))
                  }
                />
                <label className="form-label">Demanda Contratada:</label>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                      width: "100%",
                    }}
                  >
                    <input
                      type="number"
                      id="demandaContratada"
                      min={1}
                      max={1000}
                      value={demandaContratadaNumber || 1}
                      onChange={(e) =>
                        setDemandaContratadaNumber(e.target.value)
                      }
                      placeholder="Ingresa la demanda contratada..."
                    />
                    <SelectAutoComplete
                      size="small"
                      options={[
                        { label: "kW", value: "kW" },
                        { label: "MW", value: "MW" },
                        { label: "GW", value: "GW" },
                      ]}
                      field="unidadMedida"
                      fieldC="value"
                      width={"115px"}
                      value={unidadMedida || {}}
                      placeholder="Unidad..."
                      onChange={(e, value) => setUnidadMedida(value)}
                    />
                  </div>
                  <span style={{ color: "gray", fontSize: "13px" }}>
                    Equivale a{" "}
                    {demandaContratadaKW
                      ? demandaContratadaKW
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0"}{" "}
                    kW.
                  </span>
                </div>

                <label className="form-label">Dirección:</label>
                <input
                  className="form-input"
                  type="text"
                  name="direccion"
                  placeholder="Ingresa dirección"
                  value={proyectoData.direccion || ""}
                  onChange={(e) =>
                    setProyectoData((prev) => ({
                      ...prev,
                      direccion: e.target.value,
                    }))
                  }
                  onClick={(e) => {
                    e.target.blur();
                    setTimeout(() => setIsMapModalOpen(true), 0);
                  }}
                />
                <label className="form-label">Estado:</label>
                <SelectAutoComplete
                  size="small"
                  options={states}
                  field="proyecto.estado"
                  fieldC="nombreEstado"
                  width={"100%"}
                  value={proyectoData?.estado || {}}
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({ ...prev, estado: value }))
                  }
                />

                {isMapModalOpen && (
                  <div className="map-floating-modal">
                    <MapModal
                      key={isMapModalOpen ? "open" : "closed"}
                      onClose={() => setIsMapModalOpen(false)}
                      onSelectLocation={handleLocationSelect}
                      initialLocation={{
                        lat: proyectoData.latitude || 19.4326,
                        lng: proyectoData.longitude || -99.1332,
                        address: proyectoData.direccion || "",
                      }}
                    />
                  </div>
                )}
              </div>
            </Box>
          </Box>
        </Box>
      );
    }

    // PASO 5: Estructura de desglose de trabajo (igual patrón de nuevo/existe)
    if (activeStep === 4) {
      return (
        <Box
          sx={{
            borderRadius: "10px",
            backgroundColor: "white",
            boxShadow: "0px 0px 5px 2px #DDDDDD",
            padding: "24px",
            minHeight: "562px",
          }}
        >
          <h1 style={{ justifySelf: "center" }} className="stepper-title">
            {steps[4]}
          </h1>

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <CustomButton
                background={tipos[4] === "nuevo" ? "#223D51" : "#FFFFFF"}
                color={tipos[4] === "nuevo" ? "#FFFFFF" : "#223D51"}
                text="Crear nuevo"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => {
                  changeTipo(4, "nuevo");
                }}
                type="button"
                disabled={user && user.perfil && !user.perfil.esAdministrador}
              />
              <CustomButton
                background={tipos[4] === "existente" ? "#223D51" : "#FFFFFF"}
                color={tipos[4] === "existente" ? "#FFFFFF" : "#223D51"}
                text="Existente"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => changeTipo(4, "existente")}
                type="button"
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              paddingY: "20px",
            }}
          >
            {tipos[4] === "existente" && (
              <Box>
                <SelectAutoComplete
                  options={typeWorks}
                  fieldC="nombre"
                  field="tipoTrabajo"
                  value={proyectoData.tipoTrabajo || ""}
                  onChange={(e, value) =>
                    setProyectoData((prev) => ({ ...prev, tipoTrabajo: value }))
                  }
                />
              </Box>
            )}
            {tipos[4] === "nuevo" && (
              <div style={{ width: "100%" }}>
                <EDTStepper
                  API_URL={API_URL}
                  typeWorks={typeWorks}
                  newProject={true}
                  handleComplete={handleCompleteCreateEDT}
                  ref={edtRef}
                />
              </div>
            )}
          </Box>
        </Box>
      );
    }

    return null;
  };

  return (
    <Box sx={{ width: "100%", padding: "5px" }}>
      <EditProjectModal
        API_URL={API_URL}
        open={openModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmModal}
        proyecto={proyectoData.proyecto}
        tipoReportes={tipoReportes}
        usuariosHabilitadosPM={usuariosHabilitadosPM}
      />
      <EditClientModal
        API_URL={API_URL}
        open={openModalCliente}
        onClose={() => setOpenModalCliente(false)}
        onConfirm={handleConfirmModalCliente}
        cliente={proyectoData.cliente}
      />
      <EditPermisionarioModal
        API_URL={API_URL}
        open={openModalPermisionario}
        onClose={() => setOpenModalPermisionario(false)}
        onConfirm={handleConfirmModalPermisionario}
        permisionario={proyectoData.permisionario}
      />
      <ClienteContractualModal
        open={openClienteContractualModal}
        onClose={() => setOpenClienteContractualModal(false)}
        onConfirm={(value) => {
          setSelectedClienteContractual(value);
          setOpenClienteContractualModal(false);
        }}
        options={clientesContractuales}
      />
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <Stepper
        nonLinear
        activeStep={activeStep}
        sx={{
          display: { xs: "inline-block", sm: "ruby", md: "flex" }, // móvil, tablet, pc
        }}
      >
        {steps.map((label, index) => (
          <Step key={label} completed={completed[label]}>
            <StepLabel
              icon={index + 1}
              style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                className="stepper-label"
                style={{ marginTop: 8, textAlign: "center" }}
              >
                {label}
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ padding: "5px" }}>
        {allStepsCompleted() ? (
          <React.Fragment>
            <Typography className="stepper-text" sx={{ mt: 2, mb: 1 }}>
              El proyecto fue creado/editado exitosamente.
            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div
              style={{
                borderRadius: "10px",
                backgroundColor: "#D9D9D9",
                width: "100%",
              }}
            >
              <Typography className="stepper-text" sx={{ mt: 2, mb: 1, py: 1 }}>
                Paso {activeStep + 1}
              </Typography>
            </div>

            {renderStepContent()}

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                pt: 2,
              }}
            >
              <CustomButton
                background={"gray"}
                color={"#FFFFFF"}
                text={"Volver"}
                width="100px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px"
                type="button"
                onClick={handleBack}
                visibility={
                  activeStep !== 0 && (!edit || (edit && activeStep === 4))
                    ? "visible"
                    : "hidden"
                }
              />

              {/* {activeStep === 2 && tipos[2] === "nuevo" && !edit && (
                <CustomButton
                  background={"#62C776"}
                  color={"#FFFFFF"}
                  text={"Crear y terminar"}
                  width="140px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px"
                  type="button"
                  onClick={() => handleComplete(true)}
                />
              )} */}

              <CustomButton
                background={"#62C776"}
                color={"#FFFFFF"}
                text={activeStep === 4 ? "Siguiente" : "Siguiente"}
                width="100px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px"
                type="button"
                onClick={handleComplete}
              />
            </Box>
          </React.Fragment>
        )}
      </Box>
    </Box>
  );
}
